import { nameOfFactory } from "@libs/utils/name-of.utils.ts";

export interface ReviewConditionModalValues {
  consultCondition?: string;
  apptCondition?: string;
  unlinkCondition?: ReviewConditionUnlinkKeys;
}

export enum ReviewConditionUnlinkKeys {
  unlink = "unlink",
  noChange = "noChange"
}

export const reviewConditionNameOf =
  nameOfFactory<ReviewConditionModalValues>();
